
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal/transactions/[[...slug]]",
      function () {
        return require("private-next-pages/personal/transactions/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal/transactions/[[...slug]]"])
      });
    }
  